import { SYNC_TONE_LABELS, formatAgo, syncTone } from '../lib/format'
import type { IntegrationSummary } from '../lib/types'

/** Groen als er binnen het uur is gesynchroniseerd, amber ouder, rood bij een fout, grijs als uit. */
export default function SyncChip({ integration }: { integration: IntegrationSummary }) {
  const tone = syncTone(integration)
  const detail = tone === 'error' ? integration.lastSyncError : formatAgo(integration.lastSyncedAt)

  return (
    <span className={`chip ${tone}`} title={detail ?? undefined}>
      <i className={`dot ${tone}`} aria-hidden="true" />
      {integration.label}
      <span className="muted small">· {SYNC_TONE_LABELS[tone]}</span>
    </span>
  )
}
